import BaseRequest from './BaseRequest';

const schema = 'order';

export default class OrderHistoryRequest extends BaseRequest {
  fetchFilterOrderHistory(params) {
    const url = `${schema}/range-filter`;
    return this.get(url, params);
  }

  fetchOrderHistory(params) {
    const url = `${schema}/paginate`;
    return this.get(url, params);
  }

  fetchUserOpenOrder(params) {
    const url = `${schema}/open-orders`;
    return this.get(url, params);
  }

  searchOrderById(params) {
    const url = `${schema}/single`;
    return this.get(url, params);
  }
  // fetchOrderPaginate(params) {
  //   const url = `${schema}/open-orders`;
  //   return this.get(url, params);
  // }
}
